/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonIcon/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonIcon({
  children,
  viewPath = "/DesignSystem/ButtonIcon",
  innerRef,
  backgroundColor = "rgba(111,111,111, 0)",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  marginTop = 0,
  marginRight = 0,
  marginLeft = 0,
  marginBottom = 0,
  onClick,
  goTo,
  isDisabled,
  paddingTop = 8,
  paddingLeft = 8,
  paddingBottom = 8,
  paddingRight = 8,
  opacity = 1,
  borderColor = "rgba(0,188,112, 0)",
  cursor = "pointer",
  hoveredBackgroundColor = "rgba(111,111,111, 0.1)",
  isSelected,
  selectedBackgroundColor = "rgba(0,188,112, 0.1)"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
  return (<React.Fragment
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="ButtonIcon.Horizontal"
  data-view-path={viewPath}
 ref={innerRef}
 {...isHoveredBind}
 onClick={onClick}
 disabled={isDisabled}
 style={{'--bblr-2-Z2ilrAV': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-Z2ilrAV': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-4-Z2ilrAV': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-5-Z2ilrAV': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--mt-6-Z2ilrAV': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-7-Z2ilrAV': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-8-Z2ilrAV': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mb-9-Z2ilrAV': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--pt-10-Z2ilrAV': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pl-11-Z2ilrAV': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pb-12-Z2ilrAV': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pr-13-Z2ilrAV': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--o-14-Z2ilrAV': opacity,'--bc-15-Z2ilrAV': borderColor,'--c-16-Z2ilrAV': cursor,'--bc-1-Z2ilrAV': isSelected ? selectedBackgroundColor : isHovered ? hoveredBackgroundColor : backgroundColor}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</a>
</React.Fragment>)
}